import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface TourPlace {
  name: string;
  image: string | null;
}

export const useTourPlaces = (placeNames: string[] | null) => {
  const [places, setPlaces] = useState<TourPlace[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlaces = async () => {
      if (!placeNames || placeNames.length === 0) {
        setPlaces([]);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('podcasts')
          .select('Name, Image')
          .in('Name', placeNames);

        if (error) throw error;

        // Filter only places that have images
        const placesWithImages = (data || [])
          .filter(place => place.Image)
          .map(place => ({
            name: place.Name,
            image: place.Image,
          }));

        setPlaces(placesWithImages);
      } catch (error) {
        console.error('Error fetching tour places:', error);
        setPlaces([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPlaces();
  }, [placeNames?.join(',')]);

  return { places, loading };
};
